"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleMetricsReporter = void 0;
exports.ModuleMetricsReporter = function (metricsReporter, module) {
    var formatMetricName = function (metric) {
        return metric + "-" + module.name;
    };
    return {
        meter: function (metricName) {
            return metricsReporter.meter(formatMetricName(metricName));
        },
        runAsyncAndReport: function (asyncMethod, methodName) {
            return metricsReporter.runAsyncAndReport(asyncMethod, formatMetricName(methodName));
        },
        reportError: function (err) {
            metricsReporter.meter(formatMetricName('error'));
            return metricsReporter.reportError(err);
        }
    };
};
